let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("yuLnu")).then(() => parcelRequire('e1RZ8'));